var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "500px",
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("customer::customers-notice::send_email")) + " "
        ),
      ]),
      _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
        _vm._v(
          _vm._s(_vm.$t("customer::customers-notice::email_send_to")) +
            " " +
            _vm._s(_vm.count.label) +
            " " +
            _vm._s(_vm.$t("customer::customers-notice::user")) +
            " （ " +
            _vm._s(_vm.$t("customer::customers-notice::total")) +
            _vm._s(_vm.count.num) +
            _vm._s(_vm.$t("customer::customers-notice::single")) +
            "）"
        ),
      ]),
      _vm.params.delayToSendDate
        ? [
            _vm.checkDelay
              ? _c(
                  "el-form",
                  { attrs: { "label-position": "right" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "customer::customers-notice::send_time"
                          ),
                          prop: "sendTime",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "160px" },
                          attrs: {
                            type: "date",
                            placeholder: _vm.$t(
                              "customer::customers-notice::select_long_date"
                            ),
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerDate,
                          },
                          model: {
                            value: _vm.date,
                            callback: function ($$v) {
                              _vm.date = $$v
                            },
                            expression: "date",
                          },
                        }),
                        _c("el-time-select", {
                          staticStyle: { width: "160px" },
                          attrs: {
                            "picker-options": _vm.pickerTime,
                            placeholder: _vm.$t(
                              "customer::customers-notice::select_time"
                            ),
                          },
                          model: {
                            value: _vm.time,
                            callback: function ($$v) {
                              _vm.time = $$v
                            },
                            expression: "time",
                          },
                        }),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.checkDelay,
                                expression: "checkDelay",
                              },
                            ],
                            staticStyle: { color: "#d9001b" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("customer::customers-notice::over_time")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("customer::customers-notice::send_time")) +
                      "： " +
                      _vm._s(_vm.date) +
                      " " +
                      _vm._s(_vm.time)
                  ),
                ]),
          ]
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "medium" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("customer::customers-notice::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "medium",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.submitForm },
            },
            [_vm._v(_vm._s(_vm.$t("customer::customers-notice::confirm")))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }